// src/js-dot/core/constants/regex.ts
var _NUMBER = /^[+-]?\d+$/;
var _NUMERIC = /^[+-]?\d+(\.\d+)?$/;
var _EMAIL = /^\w[_\-+\w]*@([\-\w]+)(\.[\-\w]+)+$/;
var _TEL = /^(\+\d{1,3}(?:(?:\s\d{1,4}){1,2})?\s)?(\d{2,4}(?:-\d{3,4}(?:-\d{4})?))$/;
var _UNIX_TIME = /^\d{13}$/;
var _TIMESTAMP = /^(?:(\d{2,4})[-./](1[012]|0?\d)[-./]([12]\d|3[01]|0?\d)(?:[T\s](1\d|2[0-4]|0?\d)(?:\:([1-5]\d|0?\d)(?:\:(?:([1-5]\d|0?\d))(?:\.(\d+)?Z?)?)?)?)?([+-]\d{2}:?\d{2})?|.+ GMT)$/;
var _MAPPABLE_PATH = /^(\/?:?[\w-_]+)(\/:?[\w-_]+)*$/;
var _IP = /^(\d{1,3}(\.\d{1,3}){3}|[\da-f]{4}(?::([\da-f]{1,4})?){1,7})$/i;
var _IP4 = /^(2(?:[0-4]\d|5[0-5])|1\d\d|\d\d?)\.(2(?:[0-4]\d|5[0-5])|1\d\d|\d\d?)\.(2(?:[0-4]\d|5[0-5])|1\d\d|\d\d?)\.(2(?:[0-4]\d|5[0-5])|1\d\d|\d\d?)$/;
var _SHORTEN_IP6 = /^[a-f\d]{0,4}(::?[a-f\d]{0,4}){0,6}(::?(\d{1,3}(\.\d{1,3}){3}(\/\d+)?|[a-f\d]{0,4}))$/i;
var _FULL_IP6 = /^[a-f\d]{1,4}([a-f\d]{1,4}){6}(:(\d{1,3}(\.\d{1,3}){3}(\/\d+)?|[a-f\d]{0,4}))$/i;
var _TRUE_LIKE = /^true|\+?[1-9]\d*$/i;
var _ID = /^[_a-z][_\w]*$/;
var _URL = /^(?:(?:([a-z]+:)\/\/)?([^.:/?]+(?:\.[^.:/?]+)*)?(?::(\d+))?)?((?:\.|\.\.(?:\/\.\.)*)?(?:\/[^?#\/]*)+)?(\?[^#]+)?(#.*)?$/;
var _URLS = /(([a-z]+)?:\/\/(localhost|\d{1,3}(?:\.\d{1,3}){3}|\w+(?:\.\w+){1,})(?:\:(\d{1,5}))?(?:(\/[^/?#\s\n:]+)+)?(?:\?([^#\s\n]+))?(?:#([^\s\n]+))?)/g;
var _HOST = /^(localhost|[^.:/?]+(?:\.[^.:/?]+)*)?(?::(\d+))?$/;
var _SNAKE_CASE = /^[_a-z][_a-z0-9]*$/;
var _UPPER_SNAKE_CASE = /^[_A-Z][_A-Z0-9]*$/;
var _PASCAL_CASE = /^[A-Z][a-z\d]*([A-Z][a-z\d]*)*$/;
var _CAMEL_CASE = /^[a-z][a-z\d]*([A-Z][a-z\d]*)*$/;
var _SPINAL_CASE = /^[a-z][a-z0-9]*(-[a-z][a-z0-9]*)*$/;
var _KEBAB_CASE = _SPINAL_CASE;

// src/js-dot/core/functions/arrays/arrayify.ts
var {
  isArray: IS_ARRAY
} = Array;
function arrayify(target) {
  if (IS_ARRAY(target)) {
    return target;
  }
  if (target && target.constructor === Object) {
    return Object.values(target);
  }
  return [target];
}

// src/js-dot/core/functions/arrays/get-array.ts
function getArray(length, value) {
  const result = [];
  let current = length;
  while (current-- > 0) {
    result[current] = value;
  }
  return result;
}

// src/js-dot/core/functions/arrays/get-column.ts
function getColumn(items, propertyName) {
  const values = [];
  const end = items?.length;
  let current = -1;
  while (++current < end) {
    values[values.length] = items[current][propertyName];
  }
  return values;
}

// src/js-dot/core/functions/arrays/get-numbers.ts
function getNumbers(min_or_max, max) {
  let min = min_or_max;
  if (!max) {
    max = min;
    min = 0;
  }
  max++;
  const items = [];
  do {
    items[items.length] = min;
  } while (++min < max);
  return items;
}

// src/js-dot/core/functions/arrays/get-last.ts
function getLast(items) {
  return items[items.length - 1];
}

// src/js-dot/core/functions/arrays/get-count.ts
function getCount(items, match) {
  let count = 0;
  let current = items.length;
  while (current-- > 0) {
    if (items[current] === match) {
      count++;
    }
  }
  return count;
}

// src/js-dot/core/functions/arrays/get-sum.ts
function getSum(items) {
  let current = items.length;
  let total = 0;
  while (current-- > 0) {
    total += items[current];
  }
  return total;
}

// src/js-dot/core/functions/arrays/to-prefix-with.ts
function toPrefixWith(items, prefix) {
  const result = [];
  let current = items.length;
  while (current-- > 0) {
    result[current] = prefix + items[current];
  }
  return result;
}

// src/js-dot/core/functions/arrays/to-suffix-with.ts
function toSuffixWith(items, suffix) {
  const result = [];
  let current = items.length;
  while (current-- > 0) {
    result[current] = items[current] + suffix;
  }
  return result;
}

// src/js-dot/core/functions/arrays/to-flat.ts
function toFlat(items) {
  const {
    isArray: isArray3
  } = Array;
  const {
    push
  } = Array.prototype;
  return (toFlat = function (items2) {
    const flatten2 = [];
    const end = items2.length;
    let current = -1;
    while (++current < end) {
      const item = items2[current];
      if (isArray3(item)) {
        push.apply(flatten2, toFlat(item));
      } else {
        flatten2.push(item);
      }
    }
    return flatten2;
  }).apply(this, arguments);
}

// src/js-dot/core/functions/arrays/to-filled.ts
function toFilled(items) {
  const result = [];
  const end = items.length;
  let current = -1;
  while (++current < end) {
    const item = items[current];
    if (!(item === null || item === void 0)) {
      result[result.length] = item;
    }
  }
  return result;
}

// src/js-dot/core/functions/random.ts
var {
  random: RANDOM,
  round: ROUND
} = Math;
var {
  values: VALUES
} = Object;
var RANDOMIZED_MAP = /* @__PURE__ */new WeakMap();
function random(min_or_max_or_target, max) {
  const target = min_or_max_or_target;
  if (!target && target !== 0) {
    throw new ReferenceError("Cannot get a randomized value from null likes.");
  }
  if (Array.isArray(target)) {
    const {
      length
    } = target;
    let value;
    do {
      value = target[random(target.length - 1)];
    } while (length > 1 && RANDOMIZED_MAP.get(target) === value);
    RANDOMIZED_MAP.set(target, value);
    return value;
  }
  switch (typeof target) {
    case "object":
      const values = VALUES(target);
      const {
        length
      } = values;
      let value;
      do {
        value = target[random(values.length - 1)];
      } while (length > 1 && RANDOMIZED_MAP.get(target) === value);
      RANDOMIZED_MAP.set(target, value);
      return value;
    case "string":
      return target.charAt(random(0, target.length - 1));
  }
  let min = target;
  if (!max) {
    max = min;
    min = 0;
  }
  const stringMax = "" + max;
  const point = stringMax.indexOf(".");
  const decimalSize = point > -1 ? stringMax.length - point : 0;
  if (decimalSize) {
    const byTen = 10 * decimalSize;
    min *= byTen;
    max *= byTen;
    return +((ROUND(RANDOM() * (max - min)) + min) / byTen).toFixed(decimalSize);
  }
  return ROUND(RANDOM() * (max - min)) + min;
}

// src/js-dot/core/functions/arrays/to-shuffle.ts
function toShuffle(items) {
  const shuffled = [...items];
  const end = shuffled.length;
  const max = end - 1;
  let current = -1;
  while (++current < end) {
    const toIndex = random(max);
    const fromValue = shuffled[current];
    shuffled[current] = shuffled[toIndex];
    shuffled[toIndex] = fromValue;
  }
  return shuffled;
}

// src/js-dot/core/functions/arrays/to-number.ts
function toNumber(items) {
  const result = [];
  const end = items.length;
  let current = -1;
  while (++current < end) {
    result[current] = +items[current];
  }
  return result;
}

// src/js-dot/core/functions/arrays/to-unique.ts
function toUnique(items) {
  const result = [];
  const end = items.length;
  let current = -1;
  while (++current < end) {
    const item = items[current];
    if (result.indexOf(item) < 0) {
      result[result.length] = item;
    }
  }
  return result;
}

// src/js-dot/core/functions/arrays/wrap-strings.ts
function getNormalizedOption(starts_or_option, ends, separator) {
  return typeof starts_or_option === "string" ? {
    firstStarts: "",
    starts: starts_or_option || "",
    separator: separator || "",
    ends: ends || starts_or_option || "",
    lastEnds: ""
  } : {
    firstStarts: "",
    starts: "",
    separator: "",
    ends: "",
    lastEnds: "",
    ...starts_or_option
  };
}
function toWrapString(items, starts_or_option, ends, separator) {
  if (!items?.length) {
    return "";
  }
  const {
    firstStarts,
    starts,
    separator: separator_,
    ends: ends_,
    lastEnds
  } = getNormalizedOption(starts_or_option, ends, separator);
  return firstStarts + starts + items.join(ends_ + separator_ + starts) + ends_ + lastEnds;
}
function fromWrapString(wrappedString, starts_or_option, ends, separator) {
  if (!wrappedString || !(wrappedString = wrappedString.trim()).length) {
    return [];
  }
  const {
    firstStarts,
    starts,
    separator: separator_,
    ends: ends_,
    lastEnds
  } = getNormalizedOption(starts_or_option, ends, separator);
  const startString = firstStarts + starts;
  const endString = ends_ + lastEnds;
  if (!wrappedString.startsWith(startString)) {
    throw new ReferenceError(`"${wrappedString}" does not starts with "${startString}"`);
  }
  if (!!wrappedString.endsWith(endString)) {
    throw new ReferenceError(`"${wrappedString}" does not ends with "${endString}"`);
  }
  return wrappedString.substring(startString.length, wrappedString.length - endString.length).split(ends_ + separator_ + starts);
}

// src/js-dot/core/functions/arrays/bytes-to-hex.ts
function bytesToHex(byteArray) {
  const result = [];
  const end = byteArray.length;
  let current = -1;
  while (++current < end) {
    const hex = byteArray[current].toString(16).toUpperCase();
    result[current] = hex.length === 1 ? "0" + hex : hex;
  }
  return result.join("");
}

// src/js-dot/core/functions/arrays/locale-compare-by.ts
function localeCompareBy(key) {
  return function (a, b) {
    return a[key].localeCompare(b[key]);
  };
}

// src/js-dot/core/functions/strings/is-quoted.ts
function isQuoted(target) {
  if (typeof target !== "string") {
    return false;
  }
  switch (target.charAt(0)) {
    case "'":
      return target.endsWith("'") ? 1 : false;
    case '"':
      return target.endsWith('"') ? 2 : false;
  }
  return false;
}

// src/js-dot/core/functions/strings/is-braced.ts
function isBraced(target) {
  if (typeof target !== "string") {
    return false;
  }
  switch (target.charAt(0)) {
    case "(":
      return target.endsWith(")") ? 1 : false;
    case "[":
      return target.endsWith("]") ? 2 : false;
    case "{":
      return target.endsWith("}") ? 3 : false;
  }
  return false;
}

// src/js-dot/core/functions/strings/is-json-string.ts
function isJsonString(target) {
  if (typeof target !== "string") {
    return false;
  }
  switch (isQuoted(target)) {
    case 2:
      switch (isBraced(target)) {
        case 2:
        case 3:
          return 2;
      }
      return 3;
  }
  switch (isBraced(target)) {
    case 2:
    case 3:
      return 1;
  }
  return false;
}

// src/js-dot/core/functions/objects/copy-properties.ts
var {
  getOwnPropertyDescriptors: GET_OWN_PROPERTY_DESCRIPTORS,
  getOwnPropertyNames: GET_OWN_PROPERTY_NAMES,
  defineProperty: DEFINE_PROPERTY
} = Object;
var PROPERTY_AND_DESCRIPTORS = /* @__PURE__ */new WeakMap();
function copyProperties(source, target) {
  const {
    constructor
  } = source;
  if (!PROPERTY_AND_DESCRIPTORS.has(constructor)) {
    PROPERTY_AND_DESCRIPTORS.set(constructor, [GET_OWN_PROPERTY_NAMES(constructor), GET_OWN_PROPERTY_DESCRIPTORS(constructor.prototype)]);
  }
  const [properties, descriptors] = PROPERTY_AND_DESCRIPTORS.get(constructor);
  let current = properties.length;
  while (current-- > 0) {
    const property = properties[current];
    if (target.hasOwnProperty(property) || !source.hasOwnProperty(property)) {
      continue;
    }
    DEFINE_PROPERTY(target, property, {
      get() {
        return source[property];
      },
      set(value) {
        source[property] = value;
      }
    });
  }
  for (let property in descriptors) {
    if (property === "constructor" || target.hasOwnProperty(property)) {
      continue;
    }
    DEFINE_PROPERTY(target, property, {
      get() {
        return source[property];
      },
      set(value) {
        source[property] = value;
      }
    });
  }
  return source;
}

// src/js-dot/core/functions/objects/copy-properties-when.ts
function copyPropertiesWhen(target, methodName) {
  const origin = target.prototype[methodName];
  target.prototype[methodName] = function (...args) {
    return copyProperties(origin.apply(this, args), target);
  };
}

// src/js-dot/core/functions/objects/is-none.ts
function isNone(target) {
  return target === void 0 || target === null;
}

// src/js-dot/core/functions/objects/key-values.ts
var {
  entries: ENTRIES
} = Object;
function keyValues(object) {
  const keys = [];
  const values = [];
  for (const [key, value] of ENTRIES(object)) {
    const index = keys.length;
    keys[index] = key;
    values[index] = value;
  }
  return [keys, values];
}

// src/js-dot/core/functions/routes/get-host-type.ts
function getHostType(host) {
  if (_IP4.test(host)) {
    return "ip4";
  }
  if (_SHORTEN_IP6.test(host) || _FULL_IP6.test(host)) {
    return "ip6";
  }
  return "domain";
}

// src/js-dot/core/functions/diffs.ts
function diffs(before, after) {
  const beforeType = typeof before;
  const afterType = typeof after;
  if (beforeType !== afterType || afterType !== "object") {
    return after;
  }
  if (Array.isArray(after)) {
    const result2 = [];
    let current = after.length;
    while (current-- > 0) {
      const value = after[current];
      if (!before.includes(value)) {
        result2[result2.length] = value;
      }
    }
    return result2.length ? result2 : void 0;
  }
  const result = {};
  let changed;
  for (const property in after) {
    if (!after.hasOwnProperty(property)) {
      continue;
    }
    const value = after[property];
    if (property in before) {
      const beforeValue = before[property];
      if (beforeValue !== value) {
        const propertyValue = diffs(beforeValue, value);
        if (propertyValue !== void 0) {
          result[property] = diffs(beforeValue, value);
          changed || (changed = true);
        }
      }
    } else {
      result[property] = value;
      changed || (changed = true);
    }
  }
  return changed ? result : void 0;
}

// src/js-dot/core/functions/is-class.ts
function isClass(target) {
  return target?.constructor.toString() === "class" || target?.prototype?.constructor?.toString() === "class";
}

// src/js-dot/core/functions/renamed-to.ts
function renamedTo(name, method, methodName) {
  return function renamedToWrap(...args) {
    try {
      throw new SyntaxError(`${name} renamed to ${methodName || method.name}. ${name} no longer to support as soon.`);
    } catch (reason) {
      console.error(reason);
    }
    return method.apply(this, args);
  };
}

// src/js-dot/core/functions/moved-to.ts
function movedTo(method, name) {
  if (!name) {
    if (!("name" in method)) {
      throw new SyntaxError("Cannot get a name from method, enter the name to argument");
    }
    name = method.name;
  }
  return function movedToWrap(...args) {
    try {
      throw new SyntaxError(`${name} is moved to other path, check the comment for figure it.`);
    } catch (reason) {
      console.error(reason);
    }
    return method.apply(this, args);
  };
}

// src/js-dot/core/functions/downgrade-class-decorator.ts
function downgradeClassDecorator(stage3Decorator) {
  return function stage2MetaClassDecorator(...meta) {
    return function stage2ClassDecorator(target) {
      const initializers = [];
      const Extended = stage3Decorator(...meta)(target, {
        kind: "class",
        name: target.name,
        addInitializer(initializer) {
          initializers[initializers.length] = initializer;
        }
      });
      const Base = Extended || target;
      const end = initializers.length;
      let current = -1;
      while (++current < end) {
        initializers[current].call(Base);
      }
      return Base;
    };
  };
}

// src/js-dot/core/functions/downgrade-method-decorator.ts
function downgradeMethodDecorator(stage3Decorator) {
  return function stage2MetaDecorator(...meta) {
    return function stage2Decorator(target, propertyKey, descriptor) {
      const origin = target[propertyKey];
      const downgradeDescriptor = Object.assign({}, descriptor);
      downgradeDescriptor.value = function stage3MethodDecoratorTo2(...args) {
        const decoratedMethod = stage3Decorator(...meta)(origin.bind(this), {
          kind: "method",
          name: propertyKey
        });
        this[propertyKey] = function stage3MethodDecoratorTo2_replaced(...args2) {
          return decoratedMethod.apply(this, args2);
        };
        return this[propertyKey](...args);
      };
      return downgradeDescriptor;
    };
  };
}

// src/js-dot/core/functions/downgrade-property-decorator.ts
function downgradePropertyDecorator(stage3Decorator) {
  return function stage2MetaPropertyDecorator(...meta) {
    const metaDecorator = stage3Decorator(...meta);
    return function stage2PropertyDecorator(target, propertyKey, descriptor) {
      let accessGet = obj => obj[propertyKey];
      let accessSet = (obj, value) => obj[propertyKey] = value;
      if (descriptor) {
        let nothing2 = function () {};
        accessGet = descriptor.get ? obj => descriptor.get.call(obj) : nothing2;
        accessSet = descriptor.set ? (obj, value) => descriptor.set.call(obj, value) : nothing2;
      }
      const context = {
        name: propertyKey,
        kind: descriptor ? descriptor.set ? "setter" : "getter" : "field",
        access: {
          has: obj => propertyKey in obj,
          get: accessGet,
          set: accessSet
        }
      };
      let decorated;
      let stage3Descriptor;
      const decorator = metaDecorator(target, context);
      function stage2DescriptorSet(value) {
        if (!decorated) {
          stage3Descriptor = decorator.call(this);
          decorated = true;
        }
        if (stage3Descriptor?.set) {
          stage3Descriptor.set(value);
          return;
        }
        accessSet(this, value);
      }
      function stage2DescriptorGet() {
        if (!decorated) {
          stage3Descriptor = decorator.call(this);
          decorated = true;
        }
        if (stage3Descriptor?.get) {
          return stage3Descriptor.get();
        }
        return accessGet(this);
      }
      return {
        set: stage2DescriptorSet,
        get: stage2DescriptorGet,
        enumerable: false,
        configurable: true
      };
    };
  };
}

// src/js-dot/core/functions/sequencing.ts
function sequencing(callbacks) {
  return (sequencing = function laziedSequencing(callbacks2) {
    return callbacks2.length ? execute(callbacks2, []) : Promise.resolve([]);
  }).apply(this, arguments);
  function execute(callbacks2, results) {
    if (callbacks2.length) {
      return callbacks2.shift()().then(result => {
        results[results.length] = result;
        return execute(callbacks2, results);
      });
    } else {
      return Promise.resolve(results);
    }
  }
}

// src/js-dot/core/functions/booleans/is-boolean-string.ts
function isBooleanString(value) {
  switch (value) {
    case "true":
    case "True":
    case "TRUE":
    case "false":
    case "False":
    case "FALSE":
      return true;
  }
  return false;
}

// src/js-dot/core/functions/booleans/to-boolean.ts
function toBoolean(target) {
  switch (typeof target) {
    case "boolean":
      return target;
    case "string":
      return _TRUE_LIKE.test(target);
    case "number":
      return target > 0;
    case "function":
      return true;
    case "object":
      for (const propertyName in target) {
        return true;
      }
      return false;
  }
  if (Array.isArray(target)) {
    return target.length > 0;
  }
  return false;
}

// src/js-dot/core/functions/colors/parse-color.ts
var _HEX_COLOR = /^#?[0-9a-f]{3,6}$/i;
var _RGBA = /^(rgba?)?\(?(\s*,?\s*(\d+|\d+\.\d+|\.\d+)?){2,4}\)?$/;
function parseColor(source) {
  switch (typeof source) {
    case "string":
      switch (source) {
        case "transparent":
        case "blackout":
          return [0, 0, 0, 0];
        case "whiteout":
          return [255, 255, 255, 0];
      }
      if (_HEX_COLOR.test(source)) {
        const hex = source.startsWith("#") ? source.slice(1) : source;
        const {
          length
        } = hex;
        switch (length) {
          case 3:
          case 4:
            const red = hex.charAt(0);
            const green = hex.charAt(1);
            const blue = hex.charAt(2);
            const alpha = length > 3 ? hex.charAt(3) : "f";
            return [parseInt(red + red, 16), parseInt(green + green, 16), parseInt(blue + blue, 16), parseInt(alpha + alpha, 16) / 255];
          case 6:
          case 8:
            return [parseInt(hex.substr(0, 2), 16), parseInt(hex.substr(2, 2), 16), parseInt(hex.substr(4, 2), 16), length > 6 ? parseInt(hex.substr(4, 2), 16) / 255 : 1];
        }
      }
      if (_RGBA.test(source)) {
        const bracket = source.indexOf("(");
        source = (bracket > -1 ? source.substring(bracket, source.lastIndexOf(")")) : source).split(",");
      }
      break;
    case "number":
      source = [source];
      break;
  }
  if (!Array.isArray(source)) {
    throw ReferenceError(`Invalid Color Source: ${source}`);
  }
  switch (source.length) {
    case 1:
    case 2:
      const red = +source[0];
      return [red, red, red, getAlpha(source[1])];
  }
  return [+source[0], +source[1], +source[2], getAlpha(source[3])];
}
function getAlpha(alpha) {
  if (alpha === void 0 || alpha === null) {
    return 1;
  }
  if (typeof alpha === "string") {
    if (alpha.startsWith(".")) {
      alpha = "0." + alpha;
    }
    return alpha.endsWith("%") ? +alpha.substr(0, alpha.length - 1) / 100 : +alpha;
  }
  return alpha;
}

// src/js-dot/core/functions/colors/to-rgb.ts
function toRgb(source) {
  const [r, g, b, a] = parseColor(source);
  return `rgb(${r}, ${g}, ${b})`;
}

// src/js-dot/core/functions/colors/to-rgba.ts
function toRgba(source, alpha) {
  const [r, g, b, a] = parseColor(source);
  return `rgba(${r}, ${g}, ${b}, ${alpha === void 0 || alpha === null ? a : alpha})`;
}

// src/js-dot/core/functions/events/stop.ts
function stop(event) {
  event.preventDefault();
  event.stopPropagation();
  return false;
}

// src/js-dot/core/functions/numbers/is-number.ts
function isNumber(value) {
  const type = typeof value;
  return type === "number" || type === "string" ?
  // below is 47.29% slower
  // parseInt(value) == value :
  _NUMBER.test("" + value) : false;
}

// src/js-dot/core/functions/numbers/is-numeric.ts
function isNumeric(value) {
  const type = typeof value;
  return type === "number" ? true : type === "string" ?
  // Invalid with value contains `\d+(\.\d+)?`
  // return !isNaN(parseFloat(value as any))
  // Invalid with ''
  // return value == +value
  // below is 12.69% Slower
  // `parseFloat(value) == value;`
  // ' ' returns 0
  value.trim().length > 0 && value == +value : false;
}

// src/js-dot/core/functions/numbers/to-byte-format.ts
function toByteFormat(bytes, decimals) {
  const {
    floor,
    log,
    pow
  } = Math;
  const UNITS = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const BLOCK = 1024;
  const BLOCK_LOG = log(BLOCK);
  return (toByteFormat = function (bytes2, decimals2 = 2) {
    if (!bytes2) {
      return "0 " + UNITS[0];
    }
    const level = floor(log(bytes2) / BLOCK_LOG);
    return +(bytes2 / pow(BLOCK, level)).toFixed(decimals2) + UNITS[level];
  }).apply(this, arguments);
}

// src/js-dot/core/functions/numbers/to-fit.ts
function toFit(value, size = 2) {
  const stringValue = "" + value;
  const index = stringValue.indexOf(".");
  if (index > -1) {
    const length = index + size + 1;
    if (stringValue.length > length) {
      return Number(stringValue.substr(0, length));
    }
  }
  return value;
}

// src/js-dot/core/functions/numbers/to-fixed-range.ts
function toFixedRange(value, min, max) {
  if (max === void 0) {
    max = min;
    min = 0;
  }
  return value < min ? min : value > max ? max : value;
}

// src/js-dot/core/functions/numbers/zerofill.ts
function zerofill(value, size = 2) {
  value = "" + value;
  return size - value.length ? value.padStart(size, "0") : value;
}

// src/js-dot/core/functions/gps/get-distance.ts
var EARTH_RADIUS = 6378.137;
var {
  PI,
  sin,
  cos,
  sqrt,
  atan2
} = Math;
function getDistance(from_or_fromLng, to_or_fromLat, toLng, toLat) {
  let fromLng = from_or_fromLng;
  let fromLat = to_or_fromLat;
  if (Array.isArray(fromLng)) {
    toLat = fromLat[1];
    toLng = fromLat[0];
    fromLat = fromLng[1];
    fromLng = fromLng[0];
  }
  const distanceLat = toLat * PI / 180 - fromLat * PI / 180;
  const distanceLng = toLng * PI / 180 - fromLng * PI / 180;
  const a = sin(distanceLat / 2) * sin(distanceLat / 2) + cos(fromLat * PI / 180) * cos(toLat * PI / 180) * sin(distanceLng / 2) * sin(distanceLng / 2);
  const c = 2 * atan2(sqrt(a), sqrt(1 - a));
  const d = EARTH_RADIUS * c;
  return d * 1e3;
}

// src/js-dot/core/functions/objects/flatten.ts
function flatten(target) {
  const result = {};
  const keys = Object.keys(target);
  const end = keys.length;
  let current = -1;
  while (++current < end) {
    const key = keys[current];
    let value = target[key];
    if (value instanceof Object) {
      value = flatten(value);
      const childKeys = Object.keys(value);
      const childEnd = childKeys.length;
      let childCurrent = -1;
      while (++childCurrent < childEnd) {
        const childKey = childKeys[childCurrent];
        const flatKey = key + childKey.charAt(0).toUpperCase() + childKey.slice(1);
        result[flatKey] = value[childKey];
      }
    } else {
      result[key] = value;
    }
  }
  return result;
}

// src/js-dot/core/functions/objects/fusion.ts
var {
  keys: KEYS
} = Object;
var {
  isArray: IS_ARRAY2
} = Array;
function fusion(target, source) {
  if (!source) {
    return {
      ...target
    };
  }
  if (target === null || target === void 0 || typeof target !== typeof source) {
    return {
      ...source
    };
  }
  const result = {
    ...target
  };
  const keys = KEYS(source);
  let key;
  let current = keys.length;
  while (current-- > 0) {
    key = keys[current];
    const a = target[key];
    const b = source[key];
    if (a === void 0) {
      result[key] = b;
    } else {
      if (IS_ARRAY2(a) && IS_ARRAY2(b)) {
        const mergedArray = [...a];
        const arrayEnd = b.length;
        let arrayCurrent = -1;
        while (++arrayCurrent < arrayEnd) {
          const value = b[arrayCurrent];
          if (mergedArray.indexOf(value) === -1) {
            mergedArray[mergedArray.length] = value;
          }
        }
        result[key] = mergedArray;
        continue;
      }
      result[key] = a && b && typeof a === "object" && typeof b === "object" ? fusion(a, b) : b;
    }
  }
  return result;
}

// src/js-dot/core/functions/objects/object-clone.ts
function objectClone(object) {
  return JSON.parse(JSON.stringify(object));
}

// src/js-dot/core/functions/objects/extract.ts
function extract(target, keys) {
  const result = {};
  let current = keys.length;
  let key;
  while (current-- > 0) {
    key = keys[current];
    if (target.hasOwnProperty(key)) {
      result[key] = target[key];
      delete target[key];
    }
  }
  return result;
}

// src/js-dot/core/functions/objects/get-expression-type.ts
import { _EMAIL as _EMAIL2, _NUMERIC as _NUMERIC2 } from "@js-dot/core";
function getExpressionType(data) {
  const TEST_MAP = {
    number: [["timestamp", _UNIX_TIME], ["numeric", _NUMERIC2]],
    string: [["ip", _IP], ["email", _EMAIL2], ["timestamp", _TIMESTAMP], ["timestamp", _UNIX_TIME]]
  };
  return (getExpressionType = function (data2) {
    if (!data2) {
      return;
    }
    const expressions = TEST_MAP[typeof data2];
    if (!expressions) {
      return;
    }
    let current = expressions.length;
    data2 = "" + data2;
    while (current-- > 0) {
      const [type, rule] = expressions[current];
      if (rule.test(data2)) {
        return type;
      }
    }
  }).apply(this, arguments);
}

// src/js-dot/core/functions/objects/get-expression-types.ts
function getExpressionTypes(items) {
  const {
    length
  } = items;
  if (length === 0) {
    return {};
  }
  const types = {};
  let keys = Object.keys(items[0]);
  let current = -1;
  while (++current < length) {
    let currentKey = keys.length;
    const item = items[current];
    while (currentKey-- > 0) {
      const key = keys[currentKey];
      const type = getExpressionType(item[key]);
      if (type) {
        if (!types[key]) {
          types[key] = [type];
        } else {
          const target = types[key];
          const hasIndex = target.indexOf(type);
          if (hasIndex === -1) {
            target[target.length] = type;
          } else {
            keys.splice(hasIndex, 1);
          }
        }
      }
    }
  }
  keys = Object.keys(items[0]);
  current = keys.length;
  while (current-- > 0) {
    const key = keys[current];
    const type = types[key];
    types[key] = type ? type[0] : null;
  }
  return types;
}

// src/js-dot/core/functions/objects/get-first-key.ts
function getFirstKey(object) {
  for (let key in object) {
    if (object.hasOwnProperty(key)) {
      return key;
    }
  }
  return void 0;
}

// src/js-dot/core/functions/objects/is-empty.ts
function isEmpty(target) {
  switch (target) {
    case void 0:
    case null:
      return true;
  }
  switch (typeof target) {
    case "string":
      return !target.length;
    case "boolean":
      return false;
  }
  if (Array.isArray(target)) {
    return !target.length;
  }
  for (let property in target) {
    return false;
  }
  return true;
}

// src/js-dot/core/functions/objects/is-false-like.ts
function isFalseLike(target) {
  return target === false || target === 0 || isEmpty(target);
}

// src/js-dot/core/functions/objects/is-object.ts
function isObject(target) {
  return target && typeof target === "object";
}

// src/js-dot/core/functions/objects/non-nullable.ts
function nonNullable(target) {
  if (isObject(target)) {
    return Object.keys(target).reduce(objectNonNullableReducer, {
      ...target
    });
  }
}
function objectNonNullableReducer(target, key) {
  if (isEmpty(target[key])) {
    delete target[key];
  }
  return target;
}

// src/js-dot/core/functions/objects/object-extract-map.ts
function objectExtractMap(target, keys, map) {
  let current = keys.length;
  let key;
  let count = 0;
  while (current-- > 0) {
    key = keys[current];
    if (target.hasOwnProperty(key)) {
      map({
        key,
        value: target[key]
      });
      count++;
      delete target[key];
    }
  }
  return count;
}

// src/js-dot/core/functions/objects/path-walk.ts
var _KEY_LITERAL = /\[([^\]]+)]/g;
var {
  isArray: IS_ARRAY3
} = Array;
function pathWalk(object, path) {
  if (!path) {
    return void 0;
  }
  const bracket = path.indexOf("[");
  if (bracket > -1 && path.indexOf("]", bracket) > -1) {
    path = path.replace(_KEY_LITERAL, ".$1");
  } else if (path.indexOf(".") < 0) {
    return object[path];
  }
  const segments = path.split(".");
  const end = segments.length;
  let target = object;
  let current = -1;
  while (++current < end && target) {
    const segment = segments[current];
    if (!IS_ARRAY3(target) && !target.hasOwnProperty(segment)) {
      return void 0;
    }
    target = target[segment];
  }
  return target;
}

// src/js-dot/core/functions/routes/add-search-string-value.ts
function addSearchStringValue(url, searchString) {
  const [path, hash] = url.split("#");
  switch (searchString[0]) {
    case "?":
    case "&":
      searchString = searchString.slice(1);
  }
  return path + (path.indexOf("?") > -1 ? "&" : "?") + searchString + (hash ? "#" + hash : "");
}

// src/js-dot/core/functions/strings/casting.ts
function casting(value) {
  if (isNumeric(value)) {
    return +value;
  }
  if (isBooleanString(value)) {
    return toBoolean(value);
  }
  return value;
}

// src/js-dot/core/functions/routes/from-search-string.ts
function fromSearchString(searchString) {
  searchString = searchString.split("?").pop().split("#").shift();
  if (!searchString) {
    return {};
  }
  const result = {};
  const end = searchString.length;
  let current = -1;
  let char;
  let name = "";
  let value = "";
  let flag;
  while (++current < end) {
    char = searchString.charAt(current);
    if (flag) {
      if (char === "&") {
        result[name] = escapeCasting(value);
        name = "";
        value = "";
        flag = false;
      } else {
        value += char;
      }
    } else {
      switch (char) {
        case "=":
          flag = true;
          break;
        case "&":
          result[name] = escapeCasting(value);
          name = "";
          value = "";
          break;
        default:
          name += char;
      }
    }
  }
  result[name] = escapeCasting(value);
  return result;
}
function escapeCasting(value) {
  const castedValue = casting(value);
  if (typeof castedValue === "string") {
    return decodeURIComponent(castedValue);
  }
  return castedValue;
}

// src/js-dot/core/functions/routes/from-filter-string.ts
import { casting as casting2 } from "@js-dot/core";

// src/js-dot/core/date/_digit-timestamp.ts
var _DIGIT_TIMESTAMP = /^([+-])?(\d{4})(?:(\d\d)(?:(\d\d)(?:(\d\d)(?:(\d\d)(?:(\d\d)(\d+)?)?)?)?)?)?(?:\.(\d+))?$/;

// src/js-dot/core/date/from-date-digit.ts
import { getLastDate } from "@js-dot/core/date";
function fromDateDigit(digitExp_or_parts, forEnd) {
  const matched = Array.isArray(digitExp_or_parts) ? digitExp_or_parts : ("" + digitExp_or_parts).match(_DIGIT_TIMESTAMP);
  if (!matched) {
    throw RangeError(`Invalid Digit Timestamp Expression: ${digitExp_or_parts}`);
  }
  const [_, type, y, m, d, h, i, s, u, z] = matched;
  let date;
  if (forEnd) {
    const fixedM = m ? +m - 1 : 11;
    date = new Date(+y, fixedM, d ? +d : getLastDate(new Date(+y, fixedM)), h ? +h : 23, i ? +i : 59, s ? +s : 59, u ? +u.padEnd(3, "0") : 999);
  } else {
    date = new Date(+y, +m - 1 || 0, +d || 1, +h || 0, +i || 0, +s || 0, u ? +u.padEnd(3, "0") : 0);
  }
  if (z) {
    date = new Date(date.getTime() - date.getTimezoneOffset() * 6e4);
    const offset = +("" + z).padEnd(2, "0") * 36e5;
    return new Date(date.getTime() + (type === "-" ? offset : -offset));
  }
  return date;
}

// src/js-dot/core/date/is-date-digit.ts
function isDateDigit(dateDigit) {
  switch (typeof dateDigit) {
    case "number":
    case "string":
      const matched = ("" + dateDigit).match(_DIGIT_TIMESTAMP);
      return matched || false;
  }
  return false;
}

// src/js-dot/core/functions/routes/_search-query.ts
var QUERY_KEYWORD_SPACE = "+";
var QUERY_KEYWORD_OR = ",";
var QUERY_KEYWORD_OR_CONTEXT = "OR";
var QUERY_KEY_VALUE_SEPARATOR = ":";
var QUERY_KEY_AND = ";";
var _QUERY_KEYWORD_OR_CONTEXT_WITH_SPACE = new RegExp(`\\s${QUERY_KEYWORD_OR_CONTEXT}\\s`, "g");
var _QUERY_KEYWORD_OR_AFTER_SPACE = new RegExp(`${QUERY_KEYWORD_OR}\\s*`, "g");
var FILTER_KEYWORD_OR_CONTEXT = "OR";
var FILTER_KEYWORD_AND_CONTEXT = "AND";
var _FILTER_KEYWORD_OR_CONTEXT = new RegExp(`\\s*${FILTER_KEYWORD_OR_CONTEXT}\\s*`, "g");
var _FILTER_KEYWORD_AND_CONTEXT = new RegExp(`\\s*${FILTER_KEYWORD_AND_CONTEXT}\\s*`, "g");

// src/js-dot/core/functions/routes/from-filter-string.ts
function fromFilterString(filterString, option) {
  return (fromFilterString = function (filterString2, option2) {
    if (!filterString2) {
      return {};
    }
    const {
      types
    } = fusion(option2, {
      types: {}
    });
    const values = {};
    const end = filterString2.length;
    let current = -1;
    let state = true;
    let key = "";
    let value = "";
    while (++current < end) {
      const char = filterString2.charAt(current);
      if (state) {
        switch (char) {
          case QUERY_KEY_VALUE_SEPARATOR:
            state = false;
            break;
          default:
            key += char;
        }
      } else {
        switch (char) {
          case QUERY_KEY_AND:
            values[key] = castingWithTimestamp(types, key, value);
            state = true;
            key = "";
            value = "";
            continue;
          case QUERY_KEYWORD_OR:
            value += ", ";
            continue;
          case QUERY_KEYWORD_SPACE:
            value += " ";
            continue;
          default:
            value += char;
        }
      }
    }
    if (key && value) {
      values[key] = castingWithTimestamp(types, key, value);
    }
    return values;
  }).apply(this, arguments);
  function castingWithTimestamp(types, key, value) {
    switch (types[key]) {
      case "date":
        return fromDateDigit(value);
      case "text":
      case "search":
        return value;
      case "number":
        return +value;
    }
    if (isDateDigit(value)) {
      return fromDateDigit(value);
    }
    return casting2(value);
  }
}

// src/js-dot/core/functions/routes/from-usv-object.ts
function fromUsvObject(target) {
  const type = typeof target;
  switch (type) {
    case "string":
      return fromSearchString(target);
    case "function":
    case "number":
      return TypeError(type + " is cannot be USV Object");
  }
  if (Array.isArray(target)) {
    return Object.fromEntries(target);
  }
  return target || {};
}

// src/js-dot/core/functions/routes/to-usv-string.ts
function toUsvString(queryMap) {
  const queryStrings = [];
  const entries = Object.entries(queryMap);
  const end = entries.length;
  let current = -1;
  while (++current < end) {
    const [name, value] = entries[current];
    queryStrings.push(name + "=" + value);
  }
  return queryStrings.join("&");
}

// src/js-dot/core/functions/routes/to-url.ts
function toUrl(path_or_slug, queryString_or_queryMap) {
  const url = Array.isArray(path_or_slug) ? path_or_slug.join("/") : path_or_slug;
  let query = queryString_or_queryMap;
  if (typeof query === "object") {
    const queryStringArray = [];
    const queryNames = Object.keys(query);
    const end = queryNames.length;
    let current = -1;
    while (++current < end) {
      const queryName = queryNames[current];
      const queryValue = query[queryName];
      if (queryValue || queryValue === 0) {
        queryStringArray.push(queryName + "=" + queryValue);
      }
      query = queryStringArray.join("&");
    }
  }
  return addSearchStringValue(url, query);
}

// src/js-dot/core/functions/strings/start-at.ts
function startAt(value, searchString, ...moreSearchStrings) {
  moreSearchStrings.unshift(searchString);
  const end = moreSearchStrings.length;
  let current = -1;
  while (++current < end) {
    const needle = moreSearchStrings[current];
    const indexOf = value.indexOf(needle);
    if (indexOf > -1) {
      value = value.slice(indexOf + needle.length);
    }
  }
  return value;
}

// src/js-dot/core/functions/routes/get-path-class.ts
function getPathClass(url, {
  prefix,
  delimiter,
  wildcard
} = {}) {
  if (!prefix) {
    prefix = "path";
  }
  if (!delimiter) {
    delimiter = "_";
  }
  if (!wildcard) {
    wildcard = "any";
  }
  url = startAt(url, "://");
  if (url.startsWith("/")) {
    url = url.slice(1);
  }
  const searchStringIndex = url.indexOf("?");
  if (searchStringIndex > -1) {
    url = url.substr(0, searchStringIndex);
  }
  const segments = (url || "index").split("/");
  const end = segments.length;
  const classNames = [];
  let current = -1;
  const lastClassNames = [prefix];
  while (++current < end) {
    const segment = segments[current];
    let lastCurrent = lastClassNames.length;
    while (lastCurrent-- > 0) {
      const lastClassName = lastClassNames[lastCurrent];
      let className = lastClassName + delimiter + segment;
      classNames[classNames.length] = className;
      lastClassNames[lastCurrent] = className;
      if (isNumber(segment)) {
        className = lastClassName + delimiter + wildcard;
        classNames[classNames.length] = className;
        lastClassNames[lastClassNames.length] = className;
      }
    }
  }
  return classNames;
}

// src/js-dot/core/functions/routes/get-search-string-value.ts
function getSearchStringValue(queryString_or_key, key) {
  let query;
  if (key) {
    query = queryString_or_key;
  } else {
    query = location.search;
    key = queryString_or_key;
  }
  const matched = query.match(new RegExp(`${key}=([^&#]+)`));
  if (matched) {
    const value = matched[1];
    return isNumeric(value) ? Number(value) : value;
  }
  return null;
}

// src/js-dot/core/functions/routes/get-relate-protocol.ts
function getRelateProtocol(relateUrl, requestProtocol = "http") {
  const delimiterIndex = relateUrl.indexOf("://");
  if (delimiterIndex > 0) {
    const protocol = relateUrl.substr(0, delimiterIndex);
    const tlsProtocol = protocol.endsWith("s");
    return requestProtocol.endsWith("s") && requestProtocol !== "ws" ? tlsProtocol ? requestProtocol : requestProtocol.slice(1) : tlsProtocol ? requestProtocol + "s" : requestProtocol;
  }
  return requestProtocol;
}

// src/js-dot/core/functions/routes/multiple-path.ts
function multiplePath(path, separator = "|") {
  if (!path) {
    return [];
  }
  if (!path.includes(separator)) {
    return [path];
  }
  const result = [];
  const segments = path.split("/");
  const end = segments.length;
  let current = -1;
  while (++current < end) {
    const segment = segments[current];
    if (!segment.includes(separator)) {
      continue;
    }
    const slugs = segment.split(separator);
    const slugEnd = slugs.length;
    let slugCurrent = -1;
    while (++slugCurrent < slugEnd) {
      segments[current] = slugs[slugCurrent];
      const sub = segments.join("/");
      result.includes(sub) || result.push(...multiplePath(sub, separator));
    }
  }
  return result;
}

// src/js-dot/core/functions/routes/to-filter-string.ts
import { toDateDigit } from "@js-dot/core/date";
var {
  keys: KEYS2
} = Object;
var {
  isArray
} = Array;
function toFilterKeyword(value) {
  switch (typeof value) {
    case "string":
      return encodeFilterKeyword(value);
    case "number":
    case "boolean":
      return "" + value;
  }
  if (isArray(value)) {
    if (value.length === 2) {
      const [begin, end] = value;
      if (begin instanceof Date || end instanceof Date) {
        return `${begin ? toDateDigit(begin) : ""}~${end ? toDateDigit(end) : ""}`;
      }
    }
    return value.map(toFilterKeyword).join(",");
  }
  if (value instanceof Date) {
    return toDateDigit(value);
  }
  return value;
}
function encodeFilterKeyword(keyword) {
  keyword = keyword.trim();
  const end = keyword.length;
  let current = -1;
  let result = "";
  if (end > 4) {
    if (keyword.substr(0, 4) === "NOT ") {
      result += "!";
      current = 3;
    }
  }
  while (++current < end) {
    const char = keyword.charAt(current);
    const nextChar = keyword.charAt(current + 1);
    switch (char) {
      case " ":
        if (current > 3) {
          const last4 = result.substr(-4);
          if (last4.endsWith("*OR")) {
            result = result.substr(0, result.length - 3) + ",";
            break;
          }
          if (last4 === "*AND") {
            result = result.substr(0, result.length - 4) + ":";
            break;
          }
        }
        result += "+";
        break;
      case ":":
      // FILTER_CONDITION_SEPARATOR, FILTER_KEYWORD_AND
      case ";":
      // FILTER_CONDITION_AND
      case "/":
      // FILTER_CONDITION_OR
      case "!":
      // FILTER_KEYWORD_NOT
      case "*":
        result += "!" + char;
        break;
      default:
        result += char;
    }
  }
  return result;
}
function toFilterString(source, forOr = false) {
  const conditions = [];
  const keys = KEYS2(source);
  const end = keys.length;
  let current = -1;
  while (++current < end) {
    const key = keys[current];
    const value = toFilterKeyword(source[key]);
    if (!value) {
      continue;
    }
    conditions[conditions.length] = key + ":" + value;
  }
  return conditions.join(forOr ? "/" :
  // FILTER_CONDITION_OR
  ";"
  // FILTER_CONDITION_AND
  );
}

// src/js-dot/core/functions/routes/to-ws-url.ts
function toWsUrl(value) {
  value = "" + value;
  const protocol = getRelateProtocol(value, "ws") + "://";
  const delimiterIndex = value.indexOf("://");
  const segments = (delimiterIndex > -1 ? value.slice(delimiterIndex + 3) : value).split("/");
  const hostName = segments.shift();
  const path = segments.join("/");
  let uri;
  if (isNumber(hostName)) {
    uri = `${protocol}${location.hostname}:${value}`;
  } else {
    uri = `${protocol}${hostName}`;
  }
  return path ? uri + "/" + path : uri;
}

// src/js-dot/core/functions/routes/to_search_string_map.ts
var {
  isArray: isArray2
} = Array;
function toSearchStringMap(source) {
  if (!source) {
    return {};
  }
  switch (typeof source) {
    case "object":
      if (isArray2(source)) {
        const firstItem = source[0];
        if (!firstItem) {
          return {};
        }
        if (isArray2(firstItem)) {
          return Object.fromEntries(source);
        }
        return fromSearchString(source.join("&"));
      }
      return source;
    case "string":
      return fromSearchString(source);
  }
  throw RangeError("Cannot be Search String Map");
}

// src/js-dot/core/functions/routes/update-usv-object.ts
function updateUsvObject(string_or_array_or_map, source) {
  const target = toSearchStringMap(string_or_array_or_map);
  if (!source) {
    source = fromSearchString(location.search);
  } else if (typeof source === "string") {
    source = fromSearchString(source);
  } else {
    source = toSearchStringMap(source);
  }
  const map = {
    ...source
  };
  if (!target) {
    return map;
  }
  const names = Object.keys(target);
  const end = names.length;
  let current = -1;
  while (++current < end) {
    let name = names[current];
    const value = target[name];
    if (name.endsWith("?")) {
      name = name.substr(0, name.length - 1);
    }
    if (value === null || value === void 0 || value === "") {
      if (map.hasOwnProperty(name)) {
        delete map[name];
      }
    } else {
      map[name] = value;
    }
  }
  return map;
}

// src/js-dot/core/functions/routes/update-usv-string.ts
function updateUsvString(string_or_array_or_map, source) {
  return toUsvString(updateUsvObject.apply(this, arguments));
}

// src/js-dot/core/functions/routes/formalize-url-host.ts
function formalizeUrlHost(host_or_port_only) {
  let host = "" + host_or_port_only;
  if (isNumber(host)) {
    host = location.host.split(":")[0] + ":" + host;
  } else if (host.endsWith("/")) {
    host = host.substring(0, host.length - 1);
  }
  if (host.indexOf("//") < 0) {
    host = location.protocol + "//" + host;
  }
  return host;
}

// src/js-dot/core/functions/routes/formalize-url-path.ts
function formalizeUrlPath(path) {
  return path.startsWith("/") ? path : "/" + path;
}

// src/js-dot/core/functions/stores/get-cookie.ts
function getCookie(name) {
  const matched = document.cookie.match(new RegExp(`${name}=([^;]+)`));
  return matched ? matched[1] : null;
}

// src/js-dot/core/functions/stores/set-cookie.ts
function setCookie(name, value, path = "/") {
  document.cookie = `${name}=${value}; path=${path}`;
}

// src/js-dot/core/functions/strings/base64-to-bytes.ts
function base64ToBytes(base64String) {
  const key = atob(base64String);
  const end = key.length;
  const bytes = new Uint8Array(new ArrayBuffer(end));
  let current = -1;
  while (++current < end) {
    bytes[current] = key.charCodeAt(current);
  }
  return bytes;
}

// src/js-dot/core/functions/strings/base64-to-hex.ts
function base64ToHex(base64String) {
  return bytesToHex(base64ToBytes(base64String));
}

// src/js-dot/core/functions/strings/parse-agent.ts
function parseAgent(agent) {
  const _AGENT_SEGMENT = /([^\/\s,]+)(?:\/([^\(\s]+)(?:\s*\(([^)]+)\))?)?/g;
  const _DETAILS = /([a-z][^;,()]*)/g;
  const _DETAIL_SEGMENT = /([^\s\/:]*)(?:[\s\/:](.+))?$/;
  const _UNDERBAR = /_/g;
  const _NOT_NUMERIC = /[^\d.]/g;
  const PROPERTIES = [{
    target: "os",
    conditions: [["ipad", "ios", "os"], ["iphone", "ios", "os"], ["ipod", "ios", "os"], ["macintosh", "macos", "os x"], ["linux"], ["android"], ["windows", null, null, {
      10: 10,
      6.3: 8.1,
      6.2: 8,
      6.1: 7,
      6: "vista",
      5.2: "xp",
      5.1: "xp",
      5: "2000"
    }]]
  }, {
    target: "browser",
    conditions: [["safari"], ["samsungbrowser"], ["opera"], ["firefox"], ["trident", "ie"], ["msie", "ie"], ["headlesschrome", "chrome"], ["chromium", "chrome"], ["chrome"], ["edge"]]
  }];
  return (parseAgent = function (agent2) {
    agent2 = agent2.toLowerCase();
    const segments = agent2.match(_AGENT_SEGMENT);
    let current = segments.length;
    const meta = {};
    while (current-- > 0) {
      const segment = segments[current];
      const slashIndex = segment.indexOf("/");
      if (slashIndex > -1) {
        const name = segment.substr(0, slashIndex);
        const spaceIndex = segment.indexOf(" ");
        if (spaceIndex > -1) {
          meta[name] = segment.substring(slashIndex + 1, spaceIndex);
          const details = segment.slice(spaceIndex).match(_DETAILS);
          let detailCurrent = details.length;
          while (detailCurrent-- > 0) {
            const detail = details[detailCurrent];
            const detailMatched = detail.match(_DETAIL_SEGMENT);
            meta[detailMatched[1]] = detailMatched[2] || true;
          }
        } else {
          meta[name] = segment.substring(slashIndex + 1);
        }
      } else {
        meta[segment] = null;
      }
    }
    if (meta["wget"]) {
      return {
        os: "linux",
        osVersion: "unknown",
        linux: "unknown",
        browser: "wget",
        browserVersion: meta["wget"],
        wget: meta["wget"]
      };
    }
    const result = {
      os: "unknown",
      osVersion: "unknown",
      browser: "unknown",
      browserVersion: "unknown",
      mobile: false
    };
    current = PROPERTIES.length;
    while (current-- > 0) {
      const {
        target,
        conditions
      } = PROPERTIES[current];
      let conditionCurrent = conditions.length;
      while (conditionCurrent-- > 0) {
        const [property, rename, versionPrefix, reversions] = conditions[conditionCurrent];
        const value = meta[property];
        if (!value) {
          continue;
        }
        let version = parseFloat((versionPrefix ? agent2.split(versionPrefix)[1] : meta["version"] || meta["rv"] || value).replace(_UNDERBAR, ".").replace(_NOT_NUMERIC, ""));
        if (reversions) {
          const reversion = reversions[version];
          if (reversion) {
            version = reversion;
          }
        }
        const name = rename || property;
        result[target] = name;
        result[name] = version || "unknown";
        result[target + "Version"] = result[name];
        break;
      }
    }
    result.mobile = !!(meta["mobile"] || meta["android"] || meta["ios"]);
  }).apply(this, arguments);
}

// src/js-dot/core/functions/strings/parse-url.ts
function parseUrl(url) {
  if (!url) {
    return {};
  }
  const matched = url.match(_URL);
  if (!matched) {
    return {
      href: url
    };
  }
  const [href, protocol, host, port, pathname, search, hash] = matched;
  return {
    href,
    protocol,
    host,
    port,
    hostname: port ? host + ":" + port : host,
    pathname,
    search,
    hash,
    protocolValue: protocol ? protocol.substring(0, protocol.length - 1) : void 0,
    searchValue: search ? search.slice(1) : void 0,
    hashValue: hash ? hash.slice(1) : void 0
  };
}

// src/js-dot/core/functions/strings/strip-tag.ts
var _TAG = /<\/?[a-z][\w\-]*("[^"]+"|'[^']+'|[^>])*>/g;
function stripTag(html, replace = "") {
  return typeof html === "string" && html.length ? html.replace(_TAG, replace) : "";
}

// src/js-dot/core/functions/strings/strip-comment-for-json.ts
function stripCommentForJson(value) {
  const end = value.length;
  let index = -1;
  let result = "";
  loop: while (++index < end) {
    const char = value[index];
    switch (char) {
      case '"':
        result += char;
        while (++index < end) {
          const next2 = value[index];
          result += next2;
          if (next2 === '"') {
            break;
          }
        }
        continue;
      case "/":
        const next = value[index + 1];
        switch (next) {
          case "*":
            result = result.trimEnd();
            index++;
            while (++index < end) {
              if (value[index] === "*" && value[index + 1] === "/") {
                index += 1;
                continue loop;
              }
            }
            continue;
          case "/":
            result = result.trimEnd();
            while (++index < end) {
              const after = value[index];
              switch (after) {
                case "\n":
                case "\r":
                  result += after;
                  continue loop;
              }
            }
            continue;
        }
    }
    result += char;
  }
  return result;
}

// src/js-dot/core/functions/strings/to-camel-case.ts
var OTHER_CASE_DELIMITER = /[\s-_]([a-z])/g;
function toCamelCase(value) {
  if (Array.isArray(value)) {
    const {
      length
    } = value;
    return length > 1 ? value[0] + value.slice(1, length).map(transformFunction).join("") : value[0];
  }
  return value.charAt(0).toLowerCase() + value.substr(1).replace(OTHER_CASE_DELIMITER, replaceFunction);
}
function replaceFunction(target) {
  return target.toUpperCase().charAt(target.length - 1);
}
function transformFunction(word) {
  return word.substr(0, 1).toUpperCase() + word.slice(1).toLowerCase();
}
function toCapitalizedCamelCase(value) {
  const camelCased = toCamelCase(value);
  return camelCased.charAt(0).toUpperCase() + camelCased.slice(1);
}

// src/js-dot/core/functions/strings/to-capital-case.ts
var CASE_DELIMETER = /[-_]|\s+/;
var LINKED_UPPERCASE = /(.)([A-Z])/g;
function toCapitalCase(value) {
  const words = value.replace(LINKED_UPPERCASE, "$1 $2").split(CASE_DELIMETER);
  const end = words.length;
  let current = -1;
  while (++current < end) {
    const word = words[current];
    words[current] = word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }
  return words.join(" ");
}

// src/js-dot/core/functions/strings/to-kebab-case.ts
var OTHER_CASE_GLUE = /[\s_].|[A-Z]/g;
function toKebabCase(value) {
  if (!value) {
    return "";
  }
  if (Array.isArray(value)) {
    const {
      length
    } = value;
    return length > 1 ? value[0] + value.slice(1, length).join("-").toLowerCase() : value[0];
  }
  return (value.charAt(0) + value.slice(1).replace(OTHER_CASE_GLUE, transformFunction2)).toLowerCase();
}
function transformFunction2(target) {
  return "-" + target.charAt(target.length - 1).toLowerCase();
}

// src/js-dot/core/functions/strings/to-regex.ts
function toRegex(pattern, flags) {
  const _ALL = /([+?*\[\]()])/g;
  return (toRegex = function (pattern2, flags2) {
    return new RegExp(pattern2.replace(_ALL, "\\\\$1"), flags2);
  }).apply(this, arguments);
}

// src/js-dot/core/functions/strings/to-snake-case.ts
var _HYPHEN = /-/g;
function toSnakeCase(value) {
  return toKebabCase(value).replace(_HYPHEN, "_");
}

// src/js-dot/core/functions/strings/glob-to-regex.ts
function globToRegex(pattern, option) {
  option = Object.assign({
    startsWith: true,
    endsWith: true
  }, option);
  const end = pattern.length;
  let current = -1;
  let expression = "";
  while (++current < end) {
    const char = pattern[current];
    switch (char) {
      case "{":
        const matchWords = [];
        let matchWord = "";
        braceLoop: while (++current < end) {
          const inChar = pattern[current];
          switch (inChar) {
            case "}":
              if (matchWord) {
                matchWords[matchWords.length] = matchWord.trim();
              }
              expression += "(" + matchWords.join("|") + ")";
              break braceLoop;
            case ",":
              matchWords[matchWords.length] = matchWord.trim();
              matchWord = "";
              break;
            case "[":
            case "]":
            case "(":
            case ")":
            case "?":
            case "*":
            case "|":
            case ".":
            case "/":
              matchWord += "\\" + inChar;
              break;
            default:
              matchWord += inChar;
          }
        }
        continue;
      case "[":
        let matchChar = char;
        braceLoop: while (++current < end) {
          const inChar = pattern[current];
          switch (inChar) {
            case "]":
              expression += matchChar + inChar;
              matchChar = null;
              break braceLoop;
            case "*":
            case "?":
            case "/":
              matchChar += "\\" + inChar;
              break;
            default:
              matchChar += inChar;
          }
        }
        if (matchChar) {
          expression += "\\" + matchChar;
        }
        continue;
      case "*":
        if (pattern.substring(current, current + 3) === "**/") {
          current += 2;
          expression += "(\\w[\\w\\/]*/)*";
        } else {
          expression += "[^\\/]*";
        }
        continue;
      case "?":
        expression += "[^/\\s]";
        continue;
      case "]":
      case "}":
      case "(":
      case ")":
      case ".":
      case "/":
        expression += "\\" + char;
        continue;
    }
    expression += char;
  }
  return new RegExp((option.startsWith ? "^" : "") + expression + (option.endsWith ? "$" : ""));
}

// src/js-dot/core/functions/strings/has-glob.ts
var _GLOB_OPERATOR = /[?*[{]/;
function hasGlob(value) {
  return typeof value === "string" ? _GLOB_OPERATOR.test("" + value) : false;
}

// src/js-dot/core/functions/check-interval.ts
function checkInterval(timer, callback, delay = 0, ...args) {
  clearInterval(timer);
  if (!callback) {
    return null;
  }
  return setInterval(callback, delay, ...args);
}

// src/js-dot/core/functions/check-timeout.ts
function checkTimeout(timer, callback, delay = 0, ...args) {
  clearTimeout(timer);
  if (!callback) {
    return null;
  }
  return setTimeout(callback, delay, ...args);
}

// src/js-dot/core/functions/combinates.ts
function combinates(item, ...moreItems) {
  const items = toFlat([item, moreItems]);
  const end = items.length;
  const slent = Math.pow(2, end);
  const results = [];
  let result;
  let current = -1;
  let order;
  while (++current < slent) {
    result = [];
    order = -1;
    while (++order < end) {
      if (current & Math.pow(2, order)) {
        result.push(items[order]);
      }
    }
    if (result.length) {
      results.push(result);
    }
  }
  return results;
}

// src/js-dot/core/functions/is-promise.ts
function isPromise(target) {
  return target instanceof Promise || target && typeof target["then"] === "function";
}

// src/js-dot/core/functions/callify.ts
function callify(target) {
  if (typeof target === "function") {
    return target();
  }
  return target;
}

// src/js-dot/core/functions/callbackify.ts
function callbackify(target, callback) {
  if (target) {
    if (isPromise(target)) {
      target.then(value => {
        callback(void 0, value);
      }, reason => {
        callback(reason, void 0);
      });
    } else if (typeof target === "function") {
      try {
        callback(void 0, target());
      } catch (reason) {
        callback(reason, void 0);
      }
    } else {
      callback(void 0, target);
    }
  } else {
    callback(void 0, target);
  }
}

// src/js-dot/core/functions/promisify.ts
function promisify(target) {
  if (target) {
    if (isPromise(target)) {
      return target;
    }
    if (typeof target["subscribe"] === "function") {
      return new Promise((resolve, reject) => {
        target.subscribe({
          next: response_ => {
            resolve(response_);
          },
          error: reason => {
            reject(reason);
          }
        });
      });
    }
  }
  return Promise.resolve(target);
}

// src/js-dot/core/functions/permute.ts
function permute(item, ...moreItems) {
  const items = toFlat([item, moreItems]);
  const length = items.length;
  const result = [items.slice()];
  const count = new Array(length).fill(0);
  let index = 1;
  let moveTo;
  let current;
  while (index < length) {
    if (count[index] < index) {
      moveTo = index % 2 && count[index];
      current = items[index];
      items[index] = items[moveTo];
      items[moveTo] = current;
      count[index]++;
      index = 1;
      result.push(items.slice());
    } else {
      count[index] = 0;
      index++;
    }
  }
  return result;
}

// src/js-dot/core/functions/permutes.ts
function permutes(item, ...moreItems) {
  const combinated = combinates(item, ...moreItems);
  const end = combinated.length;
  let result = [];
  let current = -1;
  while (++current < end) {
    const target = combinated[current];
    result = result.concat(target.length > 1 ? permute(target) : [target]);
  }
  return result;
}

// src/js-dot/core/functions/sleep.ts
function sleep(ms) {
  return new Promise(resolve => {
    setTimeout(resolve, ms);
  });
}

// src/js-dot/core/classes/color-range.ts
var ColorRange = class _ColorRange {
  _colors;
  static from(...colors) {
    return new _ColorRange(...colors);
  }
  constructor(...colors) {
    this._colors = Array.isArray(colors[0]) ? colors[0] : colors;
  }
  getByValue(value, min, max) {
    value = +value;
    const {
      _colors
    } = this;
    if (!value) {
      return _colors[0];
    }
    if (!max) {
      max = min;
      min = 0;
    }
    const percent = Math.abs(value) / (max - min);
    const index = percent > 1 ? _colors.length - 1 : Math.round((_colors.length - 1) * percent);
    return _colors[index];
  }
};

// src/js-dot/core/classes/gradient.ts
var Gradient = class {
  _beginArray;
  _r;
  _g;
  _b;
  min;
  max;
  constructor(begin, end, min = 0, max = 1) {
    const beginArray = parseColor(begin);
    const endArray = parseColor(end);
    this._beginArray = beginArray;
    this._r = endArray[0] - beginArray[0];
    this._g = endArray[1] - beginArray[1];
    this._b = endArray[2] - beginArray[2];
    this.min = min;
    this.max = max;
  }
  _getRgbArray(value) {
    const {
      _beginArray
    } = this;
    let step = this.getStep(value);
    step = step < 0 ? 0 : step > 1 ? 1 : step;
    const {
      round
    } = Math;
    return [_beginArray[0] + round(this._r * step), _beginArray[1] + round(this._g * step), _beginArray[2] + round(this._b * step)];
  }
  getStep(value) {
    return value ? Math.min(100, Math.round((value - this.min) / (this.max - this.min) * 100)) / 100 : 0;
  }
  getRgb(value) {
    const [r, g, b] = this._getRgbArray(value);
    return `rgb(${r}, ${g}, ${b})`;
  }
  getRgba(value, alpha) {
    const [r, g, b] = this._getRgbArray(value);
    const a = alpha === void 0 ? value : 1 < alpha ? alpha / 100 : alpha;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
  }
  getHex(value) {
    const [r, g, b] = this._getRgbArray(value);
    return "#" + r.toString(16) + g.toString(16) + b.toString(16);
  }
};

// src/js-dot/core/classes/identifier.ts
var Identifier = class {
  constructor(description) {
    this.description = description;
    this.symbol = Symbol(description);
  }
  [Symbol.toStringTag];
  symbol;
  root = this;
  toString() {
    return `Identifier<${this.description}>`;
  }
  child(description) {
    return new ChildIdentifier(this, description);
  }
};
var ChildIdentifier = class extends Identifier {
  constructor(parent, description) {
    super(description);
    this.parent = parent;
    this.root = parent.root;
  }
};

// src/js-dot/core/classes/repeater.ts
var Repeater = class _Repeater {
  _current;
  _begin;
  _end;
  static from(begin, end) {
    return new _Repeater(begin, end);
  }
  constructor(begin, end) {
    if (!end) {
      end = begin;
      begin = 0;
    }
    this._begin = begin;
    this._end = end;
    this._current = 0;
  }
  previous() {
    const current = this._current--;
    if (current === this._begin) {
      this._current = this._end;
    }
    return current;
  }
  next() {
    const current = this._current++;
    if (current === this._end) {
      this._current = this._begin;
    }
    return current;
  }
  first() {
    const {
      _begin
    } = this;
    this._current = _begin;
    return _begin;
  }
  last() {
    const {
      _end
    } = this;
    this._current = _end;
    return _end;
  }
};

// src/js-dot/core/classes/iterator-base.ts
var $$items = Symbol(".iteratorBase.items");
var $$mapped = Symbol(".iteratorBase.mapped");
var $$mappedItems = Symbol(".iteratorBase.mappedItems");
var $$map = Symbol(".iteratorBase.map");
var $$filter = Symbol(".iteratorBase.filter");
var IteratorBase = class {
  /**
   * Iterable Items
   */
  [$$items];
  [$$mapped];
  get length() {
    const items = this[$$items];
    return items ? items["length"] || 0 : 0;
  }
  constructor(items) {
    this[$$items] = items;
  }
};

// src/js-dot/core/classes/array-iterator-base.ts
var ArrayIteratorBase = class extends IteratorBase {
  _iterMapApplied = [];
  *[Symbol.iterator]() {
    const items = this[$$items];
    const end = items.length;
    let current = -1;
    let filterFunction = this[$$filter];
    let mapFunction = this[$$map];
    if (filterFunction) {
      filterFunction = filterFunction.bind(this);
      if (!this[$$mapped] && mapFunction) {
        mapFunction = mapFunction.bind(this);
        const {
          _iterMapApplied
        } = this;
        while (++current < end) {
          let item = items[current];
          if (filterFunction(item)) {
            if (!_iterMapApplied[current]) {
              item = mapFunction(items[current]);
              _iterMapApplied[current] = true;
              items[current] = item;
            }
            yield item;
          }
        }
        this[$$mapped] = true;
      } else {
        while (++current < end) {
          const item = items[current];
          if (filterFunction(item)) {
            yield item;
          }
        }
      }
    } else {
      if (!this[$$mapped] && mapFunction) {
        mapFunction = mapFunction.bind(this);
        const {
          _iterMapApplied
        } = this;
        while (++current < end) {
          let item = items[current];
          if (!_iterMapApplied[current]) {
            item = mapFunction(item);
            _iterMapApplied[current] = true;
            items[current] = item;
          }
          yield item;
        }
        this[$$mapped] = true;
      } else {
        while (++current < end) {
          yield items[current];
        }
      }
    }
  }
  _getByIndex(index) {
    const items = this[$$items];
    let item = items[index];
    if (this[$$map] && !this._iterMapApplied[index]) {
      item = this[$$map](item);
      items[index] = item;
      this._iterMapApplied[index] = true;
    }
    return item;
  }
  /**
   * Get N-th item
   * @param index
   */
  get(index) {
    if (index >= this.length) {
      return void 0;
    }
    return this._getByIndex(index);
  }
  /**
   * @see Array.prototype.map
   */
  map(callback, thisArg) {
    if (thisArg) {
      callback = callback.bind(thisArg);
    }
    let index = 0;
    const result = [];
    for (const value of this) {
      result[index] = callback(value, index++, this);
    }
    return result;
  }
  /**
   * @see Array.prototype.forEach
   */
  forEach(callback, thisArg) {
    if (thisArg) {
      callback = callback.bind(thisArg);
    }
    let index = 0;
    for (const value of this) {
      callback(value, index++, this);
    }
  }
  /**
   * @see Array.prototype.slice
   */
  slice(start, end) {
    const sliced = [];
    let current = start;
    end = end ? Math.min(end, this.length) : this.length;
    while (++current < end) {
      sliced[sliced.length] = this._getByIndex(current);
    }
    return sliced;
  }
};

// src/js-dot/core/classes/object-entries-iterator-base.ts
var $$keys = Symbol(".ObjectIteratorBase.keys");
var $$entries = Symbol(".ObjectIteratorBase.entries");
var {
  keys: KEYS3
} = Object;
var ObjectEntriesIteratorBase = class extends IteratorBase {
  [$$keys];
  [$$entries];
  get length() {
    return this.keys().length;
  }
  *[Symbol.iterator]() {
    const items = this[$$items];
    let entries = this[$$entries];
    if (entries) {
      const end = entries.length;
      let current = -1;
      while (++current < end) {
        const entry = entries[current];
        yield entry;
      }
    } else {
      let mapFunction = this[$$map];
      if (mapFunction && !this[$$mapped]) {
        mapFunction = mapFunction.bind(this);
        this[$$mapped] = true;
        entries = [];
        const keys = [];
        let current = 0;
        for (let key in items) {
          if (!items.hasOwnProperty(key)) {
            continue;
          }
          let entry = entries[current];
          if (!entry) {
            entry = mapFunction([key, items[key]]);
            entries[current] = entry;
          }
          keys[current] = key;
          yield entry;
          current++;
        }
        this[$$keys] = keys;
        this[$$entries] = entries;
      }
    }
  }
  /**
   * @alias Object.keys()
   */
  keys() {
    return this[$$keys] || (this[$$keys] = KEYS3(this[$$items]));
  }
};

// src/js-dot/core/classes/primitive-logger.ts
var nothing = (...args) => {};
var PrimitiveLoggerConstructor = class {
  #typeLevels;
  #logger = console;
  #enable;
  set logger(logger) {
    logger.warn("`logger` property setter is deprecated, using `.setLogger()` method");
    this.#logger = logger;
  }
  constructor(typeLevels) {
    this.#typeLevels = typeLevels;
    const properties = {};
    for (const key in typeLevels) {
      if (!typeLevels.hasOwnProperty(key)) {
        continue;
      }
      properties[key] = {
        set(level) {
          this.#logger.warn(`\`${key}\` property setter is deprecated, using \`.setLevel()\` method`);
          this.setLevel(key, level);
        },
        get() {
          const level = typeLevels[key];
          return this.#enable && level ? this.#logger[level] : nothing;
        }
      };
    }
    Object.defineProperties(this, properties);
  }
  /**
   * Enable logging
   * @param flag
   */
  enable(flag = true) {
    this.#enable = flag;
  }
  /**
   * Disable logging
   * @param flag
   */
  disable(flag = true) {
    this.#enable = !flag;
  }
  /**
   * Set logger to logging
   * @param logger
   */
  setLogger(logger) {
    this.#logger = logger;
  }
  /**
   * Set log level
   * @param type
   * @param level
   */
  setLevel(type, level) {
    this.#typeLevels[type] = level;
  }
};
var PrimitiveLogger = PrimitiveLoggerConstructor;

// src/js-dot/core/classes/object-map.ts
import { pathWalk as pathWalk2 } from "@js-dot/core";
var ObjectMap = class {
  _map;
  constructor(map) {
    this._map = map;
  }
  /**
   * Get One of renamed property
   * @param object
   * @param name
   */
  get(object, name) {
    return pathWalk2(object, this._map[name]);
  }
  /**
   * Get All of renamed properties
   * @param object
   */
  getAll(object) {
    const {
      _map
    } = this;
    const result = {};
    for (const name in _map) {
      if (!_map.hasOwnProperty(name)) {
        continue;
      }
      result[name] = pathWalk2(object, _map[name]);
    }
    return result;
  }
};

// src/js-dot/core/classes/promise-extends-base.ts
var PromiseExtendsBase = class {
  [Symbol.toStringTag];
  _basePromise;
  _basePromiseClass;
  _basePromising(executor, promiseClass = Promise) {
    this._basePromise = new promiseClass((resolve, reject) => {
      executor(resolve, reject);
    });
    this._basePromiseClass = promiseClass;
  }
  /**
   * @inheritDoc
   * @param onfulfilled
   * @param onrejected
   */
  then(onfulfilled, onrejected) {
    return this._basePromise.then(result => {
      const next = new this._basePromiseClass((resolve, reject) => {
        resolve(onfulfilled(result));
      });
      return onrejected ? next.catch(reason => {
        return onrejected(reason);
      }) : next;
    });
  }
  /**
   * @inheritDoc
   * @param onrejected
   */
  catch(onrejected) {
    return this._basePromise.catch(onrejected);
  }
  /**
   * @inheritDoc
   * @param onfinally
   */
  finally(onfinally) {
    return this._basePromise.finally(onfinally);
  }
};

// src/js-dot/core/classes/abortable-promise.ts
var AbortablePromise = class extends PromiseExtendsBase {
  _abortController;
  constructor(executor) {
    super();
    const abortController = new AbortController();
    this._abortController = abortController;
    this._basePromising((resolve, reject) => {
      abortController.signal.addEventListener("abort", reject);
      executor(result => {
        if (!abortController.signal.aborted) {
          resolve(result);
        }
      }, reject);
    });
  }
  /**
   * Invoking this method will set this Promise's aborted flag and signal to any observers that the associated activity is to be aborted.
   *
   * [MDN Reference](https://developer.mozilla.org/docs/Web/API/AbortController/abort)
   */
  abort(reason) {
    this._abortController.abort(reason);
    return this;
  }
};

// src/js-dot/core/classes/bulk.ts
var Bulk = class extends Set {
  /**
   * Set property value to bulk set
   *
   * @example Default usage
   * class Foo {
   * 	constructor(alpha){
   * 		this.alpha = undefined;
   * 	}
   * }
   * const bulk = new Bulk;
   *
   * const a = new Foo;
   * const b = new Foo;
   *
   * bulk.add(a);
   * bulk.add(b);
   *
   * bulk.set('alpha', Math.random());
   *
   * @param property
   * @param value
   */
  set(property, value) {
    for (let entry of this) {
      entry[property] = value;
    }
  }
  /**
   * Get property value from bulk set
   *
   * @example Default usage
   * class Foo {
   * 	constructor(alpha){
   * 		this.alpha = Math.random();
   * 	}
   * }
   * const bulk = new Bulk;
   *
   * const a = new Foo;
   * const b = new Foo;
   *
   * bulk.add(a);
   * bulk.add(b);
   *
   * const values = bulk.get('alpha');
   *
   * @param property
   */
  get(property) {
    const values = [];
    for (const entry of this) {
      values[values.length] = entry[property];
    }
    return values;
  }
  /**
   *
   */
  apply(property, args) {
    const returns = [];
    for (const entry of this) {
      returns[returns.length] = entry[property].apply(entry, args);
    }
    return returns;
  }
  /**
   *
   */
  call(property, ...args) {
    const returns = [];
    for (const entry of this) {
      returns[returns.length] = entry[property].call(entry, ...args);
    }
    return returns;
  }
};

// src/js-dot/core/view/functions/remove-nodes.ts
function removeNodes(query_or_collection) {
  const nodes = Array.from(typeof query_or_collection === "string" ? document.querySelectorAll(query_or_collection) : query_or_collection);
  let current = nodes.length;
  while (current-- > 0) {
    const node = nodes[current];
    const {
      parentNode
    } = node;
    if (parentNode) {
      parentNode.removeChild(node);
    }
  }
}

// src/js-dot/core/view/classes/lazy-promise-base.ts
var LazyPromiseBase = class {
  _onRejected = [];
  _onFinally = [];
  then(onFulFilled, onRejected) {
    let promise = this._getPromise();
    const {
      _onRejected,
      _onFinally
    } = this;
    while (_onRejected.length) {
      promise = promise.catch(_onRejected.shift());
    }
    while (_onFinally.length) {
      promise = promise.finally(_onFinally.shift());
    }
    return promise.then(onFulFilled, onRejected);
  }
  catch(onRejected) {
    if (onRejected) {
      const {
        _onRejected
      } = this;
      _onRejected[_onRejected.length] = onRejected;
    }
    return this;
  }
  finally(onFinally) {
    if (onFinally) {
      const {
        _onFinally
      } = this;
      _onFinally[_onFinally.length] = onFinally;
    }
    return this;
  }
};

// src/js-dot/core/view/classes/lazy-promise.ts
var LazyPromise = class extends LazyPromiseBase {
  _executor;
  constructor(executor) {
    super();
    this._executor = executor;
  }
  _getPromise() {
    return new Promise(this._executor);
  }
};

// src/js-dot/core/view/classes/lazy-fetch.ts
var LazyFetch = class extends LazyPromiseBase {
  _input;
  _init;
  constructor(input, init) {
    super();
    this._input = input;
    this._init = init;
  }
  _getPromise() {
    return fetch(this._input, this._init);
  }
};
function lazyFetch(input, init) {
  return new LazyFetch(input, init);
}

// src/js-dot/core/view/decorators/sync-local.ts
import { renamedTo as renamedTo2 } from "@js-dot/core";

// src/js-dot/core/view/decorators/_sync-storage-factory.ts
if (!globalThis["localStorage"]) {
  globalThis["localStorage"] = void 0;
  globalThis["sessionStorage"] = void 0;
}
function syncStorageDecoratorFactory(storage) {
  return function syncStorage(defaultValue_or_option) {
    let option = defaultValue_or_option;
    if (arguments.length && typeof option !== "object") {
      option = {
        defaultValue: option
      };
    }
    return function syncStorageMetaDecorator(target, context) {
      const key = getKey(target, context.name, option);
      return function syncStorageDecorator() {
        const storaged = storage.getItem(key);
        if (storaged === null || storaged === void 0 && option && "defaultValue" in option) {
          storage.setItem(key, option["defaultValue"]);
        }
        function syncStorageSetter(value) {
          switch (value) {
            case null:
            case void 0:
              storage.removeItem(key);
              break;
            default:
              storage.setItem(key, value);
          }
        }
        function syncStorageGetter() {
          return casting(storage.getItem(key));
        }
        const {
          kind
        } = context;
        if (kind === "field") {
          return {
            set: syncStorageSetter,
            get: syncStorageGetter,
            enumerable: true,
            configurable: true
          };
        }
        const self = this;
        const access = context.access;
        return {
          set(value) {
            access.set(self, value);
            syncStorageSetter(access.get(self) || value);
          },
          get() {
            syncStorageSetter(access.get(self));
            return syncStorageGetter();
          },
          enumerable: false,
          configurable: true
        };
      };
    };
  };
  function getKey(target, name, option) {
    if (option?.key) {
      return option.key;
    }
    let key = "@syncStorage." + target.constructor.name + "." + name.toString();
    if (option?.useUrl && "location" in globalThis) {
      key += "." + (globalThis.location.href || "*");
    }
    return key;
  }
}

// src/js-dot/core/view/decorators/sync-local.ts
var syncLocal = syncStorageDecoratorFactory(localStorage);
var SyncLocal = downgradePropertyDecorator(syncLocal);
var WithLocal = renamedTo2("WithLocal", SyncLocal, "SyncLocal");

// src/js-dot/core/view/decorators/sync-session.ts
var syncSession = syncStorageDecoratorFactory(sessionStorage);
var SyncSession = downgradePropertyDecorator(syncSession);
var WithSession = renamedTo("WithSession", SyncSession, "SyncSession");

// src/js-dot/core/decorators/only-one.ts
var extendStatics = Object.setPrototypeOf || {
  __proto__: []
} instanceof Array && function (d, b) {
  d.__proto__ = b;
} || function (d, b) {
  for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
};
var ONLY_ONE_CONSTRUCTED = /* @__PURE__ */new Set();
function OnlyOne(Base) {
  function OnlyOneClass(...args) {
    if (ONLY_ONE_CONSTRUCTED.has(this)) {
      throw new SyntaxError(`Class ${Base.name} cannot construct anymore.`);
    }
    ONLY_ONE_CONSTRUCTED.add(this);
    return new Base(...args) || this;
  }
  extendStatics(OnlyOneClass, Base);
  OnlyOneClass.prototype = Base.prototype;
  return OnlyOneClass;
}

// src/js-dot/core/decorators/_get-timeout.ts
function getTimeout(self, timeout_or_propertyName) {
  return typeof timeout_or_propertyName === "number" ? timeout_or_propertyName : self[timeout_or_propertyName] || 0;
}

// src/js-dot/core/decorators/debounce.ts
var $$debounceNonFirst = Symbol("$$debounceNonFirst");
var $$debounceTimer = Symbol("$$debounceTimer");
function debounce(timeout_or_propertyName = 240, ignoreFirst = true) {
  return function debounceMetaDecorator(method, context) {
    return function debounceDecorator(...args) {
      let currentTimeout = getTimeout(this, timeout_or_propertyName);
      if (ignoreFirst && !method[$$debounceNonFirst]) {
        currentTimeout = 0;
      }
      clearTimeout(method[$$debounceTimer]);
      method[$$debounceTimer] = setTimeout(() => {
        method[$$debounceNonFirst] = true;
        method(...args);
        delete method[$$debounceTimer];
      }, currentTimeout, ...args);
    };
  };
}
var Debounce = downgradeMethodDecorator(debounce);

// src/js-dot/core/decorators/throttle.ts
var $throttleNonFirst = Symbol("$throttleNonFirst");
var $throttleTimer = Symbol("$throttleNonFirst");
var $throttleArgs = Symbol("$throttleArgs");
function throttle(timeout_or_propertyName = 240, ignoreFirst = true) {
  return function throttleMetaDecorator(method, context) {
    return function throttleDecorator(...args) {
      let currentTimeout = getTimeout(this, timeout_or_propertyName);
      if (ignoreFirst && !method[$throttleNonFirst]) {
        currentTimeout = 0;
      }
      method[$throttleArgs] = args;
      if (method[$throttleTimer]) {
        return;
      }
      clearTimeout(method[$throttleTimer]);
      method[$throttleTimer] = setTimeout(() => {
        method[$throttleNonFirst] = true;
        method(...method[$throttleArgs]);
        delete method[$throttleTimer];
        delete method[$throttleArgs];
      }, currentTimeout, ...args);
    };
  };
}
var Throttle = downgradeMethodDecorator(throttle);
export { $$entries, $$filter, $$items, $$keys, $$map, $$mapped, $$mappedItems, AbortablePromise, ArrayIteratorBase, Bulk, ChildIdentifier, ColorRange, Debounce, Gradient, Identifier, IteratorBase, LazyFetch, LazyPromise, ObjectEntriesIteratorBase, ObjectMap, OnlyOne, PrimitiveLogger, PromiseExtendsBase, Repeater, SyncLocal, SyncSession, Throttle, WithLocal, WithSession, _CAMEL_CASE, _EMAIL, _FULL_IP6, _HOST, _ID, _IP, _IP4, _KEBAB_CASE, _MAPPABLE_PATH, _NUMBER, _NUMERIC, _PASCAL_CASE, _SHORTEN_IP6, _SNAKE_CASE, _SPINAL_CASE, _TEL, _TIMESTAMP, _TRUE_LIKE, _UNIX_TIME, _UPPER_SNAKE_CASE, _URL, _URLS, addSearchStringValue, arrayify, base64ToBytes, base64ToHex, bytesToHex, callbackify, callify, casting, checkInterval, checkTimeout, combinates, copyProperties, copyPropertiesWhen, debounce, diffs, downgradeClassDecorator, downgradeMethodDecorator, downgradePropertyDecorator, extract, flatten, formalizeUrlHost, formalizeUrlPath, fromFilterString, fromSearchString, fromUsvObject, fromWrapString, fusion, getArray, getColumn, getCookie, getCount, getDistance, getExpressionType, getExpressionTypes, getFirstKey, getHostType, getLast, getNumbers, getPathClass, getRelateProtocol, getSearchStringValue, getSum, globToRegex, hasGlob, isBooleanString, isBraced, isClass, isEmpty, isFalseLike, isJsonString, isNone, isNumber, isNumeric, isObject, isPromise, isQuoted, keyValues, lazyFetch, localeCompareBy, movedTo, multiplePath, nonNullable, objectClone, objectExtractMap, objectNonNullableReducer, parseAgent, parseColor, parseUrl, pathWalk, permute, permutes, promisify, random, removeNodes, renamedTo, sequencing, setCookie, sleep, startAt, stop, stripCommentForJson, stripTag, syncLocal, syncSession, throttle, toBoolean, toByteFormat, toCamelCase, toCapitalCase, toCapitalizedCamelCase, toFilled, toFilterString, toFit, toFixedRange, toFlat, toKebabCase, toNumber, toPrefixWith, toRegex, toRgb, toRgba, toShuffle, toSnakeCase, toSuffixWith, toUnique, toUrl, toUsvString, toWrapString, toWsUrl, updateUsvObject, updateUsvString, zerofill };
